export default {
    library_categories: "Categorias",
    library_file_not_found: "Arquivo da biblioteca não encontrado",
    loading_files: "Carregando arquivos",
    no_files_are_available_at_the_moment: "Não há arquivos disponíveis no momento",
    no_files_are_available_with_the_selected_filter: "Não há arquivos disponíveis para o filtro selecionado"
}